// extracted by mini-css-extract-plugin
export default {"button":"J35gdS4930NO5bOBCW5DC","icon":"_1PkA2NWgXbJPfBYeSQAsTk","tag":"_3JWnOF0q-66frRRFDTWosC","input":"nNOb6N704saqotSci4bto"};